import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import {
  IShopCollection,
  IShopCollectionPoint,
  IShopCollectionPointsQuery,
} from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';
import { ShopCollectionPointsGQL } from './gql/shop-collection.gql.generated';

@Injectable()
export class ShopCollectionService {
  constructor(private shopCollectionPointsGQL: ShopCollectionPointsGQL) {}

  fetchCollectionPoints(
    query: IShopCollectionPointsQuery,
  ): Observable<IShopCollection<IShopCollectionPoint>> {
    return this.shopCollectionPointsGQL.fetch(query).pipe(
      mapFetchResultData(({ items, totalItemsCount }) => {
        return {
          totalItemsCount,
          items,
        };
      }),
    );
  }
}
